import React from "react";
import BasicInfoFields from "../BasicInfo/BasicInfoFields";
import { NavigationalButtons } from "./CreateCourseWizard";
import Form from "../../../../Forms/Form";

const BasicInfoStep = ({ courseId }) => {
  return (
    <div>
      <Form>
        <BasicInfoFields courseId={courseId}/>
        <NavigationalButtons
          onNextProps={{ type: "submit", text: "Save and Continue" }}
        />
      </Form>
    </div>
  );
};

export default BasicInfoStep;
